import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AgencyStateService } from '../services/agency-state.service';

export const agencyOnboardingGuard: CanActivateFn = async (_route, state) => {
  const agencyState = inject(AgencyStateService);
  const router = inject(Router);

  await agencyState.ensureInitialized();

  if (agencyState.isAgencyWithoutShops()) {
    // Return UrlTree (instead of router.navigate + return false) so the
    // /demo prefix is preserved when the agency-without-shops fallback
    // fires inside the demo subtree. (bd-1utn)
    return router.parseUrl(AgencyStateService.demoAwareUrl(state.url, '/agency/clients'));
  }

  return true;
};
